<template>
    <div>
        <DistributionStationDeliveryCheck userType="E" />
    </div>
</template>

<script>
import DistributionStationDeliveryCheck from '@/view/distributionStation-management/distributionStation-delivery-check/distributionStation-delivery-check';

export default {
    name: 'inner-sale-list',
    components: {
        DistributionStationDeliveryCheck
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>